import MainState, { MainUI } from '../State/RouterState'
import Action, { ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import { getToken } from '../../../../../../token/store'


const actionDashboard = (oldState: MainState, _action: Action): MainState => {
    window.history.pushState(null, '', '/')
    return oldState
}


const actionPaymentHistory = (oldState: MainState, _action: Action): MainState => {
    window.history.pushState(null, '', '/payments')
    return oldState
}

const actionOrderHistory = (oldState: MainState, _action: Action): MainState => {
    window.history.pushState(null, '', '/orders')
    return oldState
}

const getPanel = (api: string | null): MainUI => {
    let panel: MainUI = 'Main'

    if (window.location.pathname === '/payments') {
        if (api)
            panel = "PaymentHistory"
    } else if (window.location.pathname === '/orders') {

        if (api)
            panel = "OrderHistory"
    }

    return panel
}

const actionUpdateMainUI = (oldState: MainState, action: Action): MainState => {
    return { ...oldState, mainUI: getPanel(getToken()) }
}

const actionUrlChanged = (oldState: MainState, action: Action): MainState => {

    let panel = getPanel(getToken())
    return { ...oldState, mainUI: panel }

}

type Process = (oldState: MainState, action: Action) => MainState

export const RouterReducer: Reducer<MainState, Action> = (state: MainState = { mainUI: 'Main' }, action: Action): MainState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.MAIN_UI_DASHBOARD, actionDashboard)
    actionMap.set(ActionType.MAIN_UI_PAYMENT_HISTORY, actionPaymentHistory)
    actionMap.set(ActionType.MAIN_UI_ORDER_HISTORY, actionOrderHistory)


    actionMap.set(ActionType.URL_CHANGED, actionUrlChanged)
    actionMap.set(ActionType.UPDATE_MAIN_UI, actionUpdateMainUI)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


